import {
  Text,
  Section,
  Row,
  Column,
  Img,
  Link,
  Container,
} from '@react-email/components';
import { KYDEventListItemData } from '../../interfaces/KYDCampaign';
import dayjs from 'dayjs';
import { createTrackableLink } from '../utils/link';

const EventList = ({
  events = [],
  list_heading,
  campaign_id,
}: {
  events?: KYDEventListItemData[];
  list_heading?: string;
  campaign_id?: string;
}) => {
  return (
    <Section
      style={{
        maxWidth: '600px',
        margin: '0px auto',
        backgroundColor: 'black',
      }}
    >
      {list_heading && (
        <Row style={{ marginBottom: '10px' }}>
          <Column style={{ width: '20px', verticalAlign: 'middle' }}>
            <Container
              style={{
                width: '20px',
                height: '20px',
                backgroundColor: '#D50008',
                borderRadius: '50%',
              }}
            />
          </Column>
          <Column
            style={{
              width: 'auto',
              verticalAlign: 'middle',
              paddingLeft: '10px',
            }}
          >
            <Text
              style={{
                fontSize: '20px',
                color: '#D50008',
                fontFamily: 'Helvetica',
                lineHeight: '140%',
                letterSpacing: '0.6px',
                textTransform: 'uppercase',
                margin: '0',
              }}
            >
              {list_heading}
            </Text>
          </Column>
        </Row>
      )}
      {events.map((item, index) => {
        let link = createTrackableLink(item.event.link, {
          utm_source: 'kyd',
          utm_medium: 'email',
        });
        if (campaign_id) {
          link = createTrackableLink(link, {
            utm_campaign: campaign_id,
            utm_source: 'kyd',
            utm_medium: 'email',
            utm_id: campaign_id,
          });
        }

        return (
          <Link key={`link-${index}`} href={link}>
            <Row
              style={{
                textDecoration: 'none',
                marginBottom: '6px',
                paddingBottom: '6px',
                borderBottom: '1px solid #FFFFFF26',
              }}
            >
              <Column width="70px" style={{ verticalAlign: 'middle' }}>
                {item.event.image ? (
                  <Img
                    src={item.event.image}
                    width={70}
                    height={70}
                    style={{
                      borderRadius: '2px',
                      display: 'block',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Container
                    style={{
                      borderRadius: '2px',
                      background: '#D9D9D9',
                      width: '70px',
                      height: '70px',
                    }}
                  />
                )}
              </Column>
              <Column style={{ paddingLeft: '12px', verticalAlign: 'middle' }}>
                <Text
                  style={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.70)',
                    fontFamily: 'Helvetica, sans-serif',
                    fontWeight: 700,
                    lineHeight: '140%',
                    textTransform: 'uppercase',
                    margin: '0',
                  }}
                >
                  {item.event.start_at
                    ? dayjs(item.event.start_at).format('MMM D, YYYY')
                    : 'Event Date'}
                </Text>
                <Text
                  style={{
                    fontSize: '16px',
                    fontWeight: 700,
                    color: '#FFF',
                    fontFamily: 'Helvetica, sans-serif',
                    margin: '2px 0 0 0',
                  }}
                >
                  {item.event.name}
                </Text>
                <Text
                  style={{
                    fontSize: '16px',
                    fontWeight: 700,
                    color: '#FFF',
                    fontFamily: 'Helvetica, sans-serif',
                    margin: '2px 0 0 0',
                  }}
                >
                  {item.subcopy}
                </Text>
              </Column>
            </Row>
          </Link>
        );
      })}
    </Section>
  );
};

export default EventList;
